import {useLocation} from "react-router-dom";
import {useData} from "./useData";

export const useLinkedRecord = (parameter, fetcher, resource) => {
  const location=useLocation();
  const id=new URLSearchParams(location.search).get(parameter);
  const present=id!==null;
  const valid=present && Boolean(id.trim()) && id.length<=300 && !/[\u0000-\u001f]/.test(id);
  const result=useData(()=>valid ? fetcher(id) : Promise.resolve(null),[id],[resource]);
  return {...result,id,present,error:present&&!valid ? new Error("Linkin kohdetunniste on virheellinen.") : result.error};
};
